import * as React from 'react'
import { Modal } from 'reactstrap'

import './styles.scss'
import { Button } from 'components/Form'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const CategoryModal = ({ mode, isOpen, toggle, data, save }) => {
  const [messageError, setMessageError] = React.useState(null)
  const [category, setCategory] = React.useState('')

  React.useEffect(() => {
    setMessageError(null)

    if (mode === 'update') {
      const { category } = data.categories.find(({ category }) => category === data.categoryForEdit)
      setCategory(category)
    }
  }, [data.categories])

  const onClick = () => {
    if (!category || category.length < 0) return setMessageError(I18n.t('faqConsole_error_nameRequired'))

    if (category.toUpperCase() === (I18n.t('dashboard_general') || 'GENERAL').toUpperCase()) return setMessageError(I18n.t('faq_console_others_error'))

    if (data.categories.some(it => it.category.toUpperCase() === category.toUpperCase()) && mode !== 'update') return setMessageError(I18n.t('faq_console_duplicate_error'))

    save(category)
    setCategory('')
  }

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} className={''} contentClassName={'modal-content-category-intents'}>
      <div className='modal-wrapper-header'>
        <h1>{mode === 'add' ? I18n.t('dashboard_add-category') : I18n.t('dashboard_editCategory')}</h1>
        <span onClick={toggle}>
          <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
        </span>
      </div>

      <label htmlFor='name'>{I18n.t('dashboard_category-name')}</label>
      <input
        id={'input-modal'}
        name='name'
        type='text'
        placeholder={lang('dashboard_category-name')}
        defaultValue={category}
        onChange={(value) => setCategory(value.target.value)}
      />
      <small className='error'>{messageError}</small>

      <div className='wrapper-buttons'>
        <Button
          secondary={true}
          value={I18n.t('dashboard_save')}
          onClick={onClick}
        />
        <Button
          value={I18n.t('dashboard_cancel')}
          onClick={toggle}
        />
      </div>

    </Modal>
  )
}

export default CategoryModal
